export default __webpack_public_path__ + "static/media/spot.5cc87011.jpg";